import styled from 'styled-components';

export const StyledItem = styled.p`
  cursor: pointer;
  padding-bottom: 0;
  color: black;
`;
